function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 45.800781 11.300781 L 14.898438 11.300781 C 13.898438 11.300781 13.101562 10.5 13.101562 9.5 C 13.101562 8.5 13.898438 7.699219 14.898438 7.699219 L 45.800781 7.699219 C 46.800781 7.699219 47.601562 8.5 47.601562 9.5 C 47.601562 10.5 46.800781 11.300781 45.800781 11.300781 Z M 45.800781 11.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 7.601562 11.300781 L 2.199219 11.300781 C 1.199219 11.300781 0.398438 10.5 0.398438 9.5 C 0.398438 8.5 1.199219 7.699219 2.199219 7.699219 L 7.699219 7.699219 C 8.699219 7.699219 9.5 8.5 9.5 9.5 C 9.5 10.5 8.601562 11.300781 7.601562 11.300781 Z M 7.601562 11.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 33.101562 25.800781 L 2.199219 25.800781 C 1.199219 25.800781 0.398438 25 0.398438 24 C 0.398438 23 1.199219 22.199219 2.199219 22.199219 L 33.101562 22.199219 C 34.101562 22.199219 34.898438 23 34.898438 24 C 34.898438 25 34.101562 25.800781 33.101562 25.800781 Z M 33.101562 25.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 14.898438 40.398438 L 2.199219 40.398438 C 1.199219 40.398438 0.398438 39.601562 0.398438 38.601562 C 0.398438 37.601562 1.199219 36.800781 2.199219 36.800781 L 14.898438 36.800781 C 15.898438 36.800781 16.699219 37.601562 16.699219 38.601562 C 16.699219 39.601562 15.898438 40.398438 14.898438 40.398438 Z M 14.898438 40.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 11.300781 14.898438 C 8.300781 14.898438 5.800781 12.5 5.800781 9.398438 C 5.800781 6.300781 8.300781 4 11.300781 4 C 14.300781 4 16.800781 6.398438 16.800781 9.5 C 16.800781 12.601562 14.300781 14.898438 11.300781 14.898438 Z M 11.300781 7.601562 C 10.300781 7.601562 9.5 8.398438 9.5 9.398438 C 9.5 10.398438 10.300781 11.199219 11.300781 11.199219 C 12.300781 11.199219 13.101562 10.398438 13.101562 9.398438 C 13.101562 8.398438 12.300781 7.601562 11.300781 7.601562 Z M 11.300781 7.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 36.699219 29.5 C 33.699219 29.5 31.199219 27.101562 31.199219 24 C 31.199219 20.898438 33.601562 18.5 36.699219 18.5 C 39.800781 18.5 42.199219 20.898438 42.199219 24 C 42.199219 27.101562 39.699219 29.5 36.699219 29.5 Z M 36.699219 22.199219 C 35.699219 22.199219 34.898438 23 34.898438 24 C 34.898438 25 35.699219 25.800781 36.699219 25.800781 C 37.699219 25.800781 38.5 25 38.5 24 C 38.5 23 37.699219 22.199219 36.699219 22.199219 Z M 36.699219 22.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 18.5 44 C 15.5 44 13 41.601562 13 38.5 C 13 35.5 15.398438 33 18.5 33 C 21.601562 33 24 35.398438 24 38.5 C 24 41.601562 21.601562 44 18.5 44 Z M 18.5 36.699219 C 17.5 36.699219 16.699219 37.5 16.699219 38.5 C 16.699219 39.5 17.5 40.300781 18.5 40.300781 C 19.5 40.300781 20.300781 39.5 20.300781 38.5 C 20.398438 37.5 19.5 36.699219 18.5 36.699219 Z M 18.5 36.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 45.800781 25.800781 L 40.300781 25.800781 C 39.300781 25.800781 38.5 25 38.5 24 C 38.5 23 39.300781 22.199219 40.300781 22.199219 L 45.800781 22.199219 C 46.800781 22.199219 47.601562 23 47.601562 24 C 47.601562 25 46.800781 25.800781 45.800781 25.800781 Z M 45.800781 25.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255%,255%,255%)",
      fillOpacity: 1
    },
    d: "M 45.800781 40.398438 L 22.199219 40.398438 C 21.199219 40.398438 20.398438 39.601562 20.398438 38.601562 C 20.398438 37.601562 21.199219 36.800781 22.199219 36.800781 L 45.800781 36.800781 C 46.800781 36.800781 47.601562 37.601562 47.601562 38.601562 C 47.601562 39.601562 46.800781 40.398438 45.800781 40.398438 Z M 45.800781 40.398438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterswhite);
export default __webpack_public_path__ + "static/media/Filters white.87cf3d4abe5d2cefb47a2c126c900c35.svg";
export { ForwardRef as ReactComponent };